// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"PasswordRecoveryConfirm-PasswordRecoveryConfirm-fullWidth-2de33eb7","textAlignCenter":"PasswordRecoveryConfirm-PasswordRecoveryConfirm-textAlignCenter-16272e42"};